import React from 'react'
import BlogHero from './Blog/BlogHero'
import BlogInfo from './Blog/BlogInfo'
import Footer from './Footer'
export default function Blogger() {
  return (
    <div>
      <BlogHero />
      <BlogInfo />
      <Footer></Footer>
    </div>
  )
}
